import PropTypes from "prop-types";

export const arrivalContactShape = PropTypes.shape({
  lastName: PropTypes.string,
  firstName: PropTypes.string,
  emailAddress: PropTypes.string,
  phone: PropTypes.string,
});
